import { Button } from "../UI/button";
import { ArrowLeft, ArrowLeftRight, CalendarRange, LayoutList } from "lucide-react";
import { GiIceCube } from "react-icons/gi";
import Integrations from "../../Modules/Threads/Integrations";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkIfInqOnlyMode } from "../../Store/Reducers";
import { checkUserRights } from "../../Utils/Utilities";
import { canShowImportInquiries } from "../../Utils/FeatureFlags";

const MobileHeader = ({ title, iconLeft, actionsRight = [], isIntegrationsOpen, onIntegrationsChange, hasSelection = false, onReassignClick }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const userRights = checkUserRights();
    const isInqMode = useSelector(checkIfInqOnlyMode);

    const isThreadsPage = (title === "Threads" || location.pathname.includes('/threads')) && !location.pathname.includes('/threads-report');
    const isConnectionsPage = location.pathname === '/connections';
    const isTasksPage = location.pathname === '/tasks';
    const showIntegrations = isThreadsPage && userRights?.addThr && canShowImportInquiries();

    const displayTitle = (title === "Threads" && isInqMode) ? "Inquiries" : title;

    // Handle cold contacts toggle
    const searchParams = new URLSearchParams(location.search);
    const isColdContactsShown = searchParams.get('cold') === '1';

    const handleColdContactsToggle = () => {
        const newParams = new URLSearchParams(location.search);
        if (isColdContactsShown) {
            newParams.delete('cold');
        } else {
            newParams.set('cold', '1');
        }
        const newSearch = newParams.toString() ? `?${newParams.toString()}` : '';
        navigate(`${location.pathname}${newSearch}`);
    };

    return (
        <div className="flex items-center justify-between w-full h-16 bg-white z-10 lg:hidden px-[15px] border-b border-sahi-border-color">
            {/* Left Side */}
            <div className="text-gray-900 flex items-center gap-2 font-medium">
                <Button
                    variant="ghost"
                    size="default"
                    className="p-0 w-auto h-auto hover:bg-gray-100 rounded-full p-1"
                    onClick={iconLeft.onClick}
                >
                    <ArrowLeft className="!h-[24px] !w-[24px]" />
                </Button>
                <span className="text-lg font-medium">{displayTitle}</span>
            </div>

            {/* Right Side */}
            <div className="flex items-center gap-[16px]">
                {isConnectionsPage && (
                    <Button
                        variant="ghost"
                        size="default"
                        className={`p-0 w-auto h-auto hover:bg-gray-100 rounded-full p-1 ${isColdContactsShown ? 'bg-blue-100' : ''}`}
                        onClick={handleColdContactsToggle}
                        title={isColdContactsShown ? 'Hide cold contacts' : 'Show cold contacts'}
                    >
                        <GiIceCube className={`!h-[20px] !w-[20px] ${isColdContactsShown ? 'text-blue-500' : 'text-gray-600'}`} />
                    </Button>
                )}
                {/* {isTasksPage && (
                    <Button
                        variant="ghost"
                        size="default"
                        className="p-0 w-auto h-auto hover:bg-gray-100 rounded-full p-1"
                        onClick={() => {
                            const newParams = new URLSearchParams(location.search);
                            if (newParams.get('v') === '2') {
                                newParams.delete('v');
                            } else {
                                newParams.set('v', '2');
                            }
                            const newSearch = newParams.toString() ? `?${newParams.toString()}` : '';
                            navigate(`${location.pathname}${newSearch}`);
                        }}
                    >
                        {searchParams.get('v') === '2' ? (
                            <LayoutList className="!h-[20px] !w-[20px] text-gray-600" />
                        ) : (
                            <CalendarRange className="!h-[20px] !w-[20px] text-gray-600" />
                        )}
                    </Button>
                )} */}
                {isThreadsPage && hasSelection > 0 && (
                    <Button
                        variant="ghost"
                        size="default"
                        className="p-0 w-auto h-auto hover:bg-gray-100 rounded-full p-1"
                        onClick={onReassignClick}
                        title="Reassign selected threads"
                    >
                        <ArrowLeftRight className="!h-[20px] !w-[20px] font-bold" />
                    </Button>
                )}
                {showIntegrations && (
                    <Integrations
                        triggerText="Integrations"
                        open={isIntegrationsOpen}
                        onOpenChange={onIntegrationsChange}
                    />
                )}
                {actionsRight.map(({ icon: Icon, onClick, showBadge, badgeColor }, i) => (
                    <Button
                        key={i}
                        variant="ghost"
                        size="default"
                        className="p-0 w-auto h-auto hover:bg-gray-100 rounded-full p-1 relative"
                        onClick={onClick}
                    >
                        <Icon className="!h-[20px] !w-[20px]" />
                        {showBadge && (
                            <span
                                className="absolute top-0.5 right-0.5 w-2.5 h-2.5 rounded-full border border-white z-10 pointer-events-none"
                                style={{ backgroundColor: badgeColor || '#0B5D1E' }}
                            />
                        )}
                    </Button>
                ))}
            </div>
        </div>
    );
};


export default MobileHeader;
